import { PATTERNS } from '../constants/validations';

export const removeNonNumeric = str => str.replace(PATTERNS.ONLY_NUMERIC, '');



// WEBPACK FOOTER //
// ./src/utils/removeNonNumeric.js